import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type EuiDealerState = {
  years: readonly number[];
  incentives: readonly string[];
  privateIncentives: readonly string[];
  models: readonly string[];
  trims: readonly string[];
  quickStats: string;
  soldByList: readonly string[];
  isLoggedIntoCarFax: boolean;
  brands: readonly string[];
};

export const initialDealerState: EuiDealerState = {
  years: [],
  incentives: [],
  privateIncentives: [],
  models: [],
  trims: [],
  quickStats: 'All Deals',
  isLoggedIntoCarFax: false,
  soldByList: [],
  brands: [],
};

const dealerSlice = createSlice({
  name: 'EuiDealer',
  initialState: initialDealerState,
  reducers: {
    setYears(state, action: PayloadAction<number[]>) {
      state.years = action.payload;
    },
    setBrands(state, action: PayloadAction<string[]>) {
      state.brands = action.payload;
    },
    setIncentives(state, action: PayloadAction<string[]>) {
      state.incentives = action.payload;
    },
    setPrivateIncentives(state, action: PayloadAction<string[]>) {
      state.privateIncentives = action.payload;
    },
    setModels(state, action: PayloadAction<string[]>) {
      state.models = action.payload;
    },
    setTrims(state, action: PayloadAction<string[]>) {
      state.trims = action.payload;
    },
    setSoldByList(state, action: PayloadAction<string[]>) {
      state.soldByList = action.payload;
    },
    setQuickStats(state, action: PayloadAction<string>) {
      state.quickStats = action.payload;
    },
    setIsLoggedIntoCarFax(state, action: PayloadAction<boolean>) {
      state.isLoggedIntoCarFax = action.payload;
    },
  },
});

export const {
  setYears,
  setBrands,
  setIncentives,
  setPrivateIncentives,
  setModels,
  setTrims,
  setSoldByList,
  setQuickStats,
  setIsLoggedIntoCarFax,
} = dealerSlice.actions;

export default dealerSlice.reducer;
